import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ShiftRegisterView } from './ShiftRegisterView';
import { useShiftRegister } from './useShiftRegister';

/** Boundary child: runs the section hook in the page language. */
export const ShiftRegisterContent: React.FC = () => {
    const { i18n } = useTranslation('pages');
    const logic = useShiftRegister(i18n.language);
    return <ShiftRegisterView {...logic} />;
};
